// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39Fji","delete":"styles_delete__NoTyH","update":"styles_update__1zqDS","add":"styles_add__37n_y"};